// Components==============
import subscribeToTraining from 'actions/training/subscribe';
import Button from 'components/UI/Button';
import Checkbox from 'components/UI/Checkbox';
import { TextAreaInput, TextInput } from 'components/UI/Form/Input';
import Modal from 'components/UI/Modal';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useCloseUrlModal } from 'utilities/useCloseUrlModal';
import { useFormValues } from 'utilities/useFormValues';
import './index.module.scss';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import RadioCircle from 'components/UI/RadioCircle/RadioCircle';
import trainingIndex from 'actions/training/index';
import SingleItemDropdown from 'components/UI/SingleItemDropdown';
// =========================

const schoolOptions = [
    'Aloysius De Roosten',
    'Antoon Schellenscollege',
    'Augustinianum',
    'Baanderherencollege Praktijkonderwijs',
    'Baanderherencollege VMBO',
    'Bossche Vakschool',
    'Commanderij College',
    'De Rijzert',
    'Ds Pierson College',
    'Eckhartcollege',
    'Elde College',
    'Elzendaalcollege',
    'Fioretti College',
    'Frits Philips',
    'Gymnasium Beekvliet',
    'Gymnasium Bernrode',
    'Heerbeeck College',
    'Helder',
    'Het Hooghuis',
    'Huygens Lyceum',
    'Instelling Voortgezet Onderwijs Deurne',
    'Jacob Roelandlyceum',
    'Jan van Brabant College',
    'Kempenhorst College',
    'Lorentz Casimir Lyceum',
    'Maaslandcollege',
    'Maurick College',
    'Mavoschool Sancta Maria',
    'Merlet College Cuijk',
    'Merlet College Grave',
    'Merlet College Mill',
    'Merlet College Velp',
    'Metameer',
    'Novalis College',
    'Nuenens College',
    'Olympia',
    'Omo Scholengroep Helmond',
    'Parmant Scholen Eindhoven',
    'Pius X College',
    'Praktijkschool Eindhoven',
    'Praktijkschool Helmond',
    'ROC Summa College',
    'ROC Summa College/ Montesorri College',
    'Rodenborch College',
    'Rythovius College',
    'Sint Lucas',
    'Sint-janslyceum',
    'Sondervick College',
    'Stedelijk College',
    'Stedelijk Gymnasium Den Bosch',
    'Strabrecht College',
    'Udens College',
    'Vakcollege Eindhoven',
    'Van Maerlant Den Bosch',
    'Van Maerlantlyceum',
    'Varendonck College Asten',
    'Varendonck College Someren',
    'Voortgezet onderwijs Veghel',
    'Were Di',
    'Willibrord Gymnasium',
    'Yuverta Den Bosch',
    'Yuverta Eindhoven',
];

const schoolTrainingOptions = [
    'Stedelijk College Eindhoven Henegouwenlaan',
    'Stedelijk College Eindhoven Oude Bossche Baan',
    'Strabrecht College',
    'International School Eindhoven',
    'Basisschool Beneden Beekloop',
    'Basisschool De Ganzebloem',
    'Global College Eindhoven',
    'Silfo',
];

export default function SubscriptionModal({
    training,
    isSchoolsTrainingPage,
    isAgendaPage,
    training_url,
    basePath = 'groei',
    schoolGroup,
}) {
    const [mailConfirm, setMailConfirm] = useState('');
    const [displayMessage, setDisplayMessage] = useState('');
    const [hasManagerApproval, setHasManagerApproval] = useState(false);
    const [hasDietWishes, setHasDietWishes] = useState(null);
    const [hideSchoolField, setHideSchoolField] = useState(false);

    const { pathname } = useLocation();

    const hasDietQuestion = !!training?.diet_question;

    const {
        formValues,
        handleChange,
        setFormValues,
        clearForm,
    } = useFormValues(
        {
            first_name: '',
            tussenvoegsel: '',
            last_name: '',
            email: '',
            school_name: '',
            position: '',
            manager_name: '',
            manager_email: '',
            diet_remarks: '',
            extra_fields: '',
            op_or_oop: '',
        },
        () => setDisplayMessage('')
    );

    const {
        first_name,
        last_name,
        tussenvoegsel,
        email,
        school_name,
        position,
        manager_name,
        manager_email,
        diet_remarks,
        extra_fields,
        op_or_oop,
    } = formValues;

    const dispatch = useDispatch();
    const closeUrlModal = useCloseUrlModal();

    const [confirmModalIsOpen, setConfirmModalIsOpen] = useState(false);

    useEffect(() => {
        setFormValues((prev) => ({
            ...prev,
            extra_fields: training?.extra_fields?.length
                ? training?.extra_fields.map((field) => ({
                      question: field.attributes.question,
                      answer: '',
                  }))
                : '',
        }));
    }, [training?.extra_fields?.length]);

    useEffect(() => {
        if (isSchoolsTrainingPage && schoolGroup) {
            if (
                schoolGroup.name === 'ORION 1' ||
                schoolGroup.name === 'ORION 2'
            ) {
                setHideSchoolField(true);
                handleChange({
                    target: {
                        name: 'school_name',
                        value: 'no_school_needed',
                    },
                });
            }
        }
    }, [schoolGroup, isSchoolsTrainingPage]);

    const setSchool = (schoolName) => {
        handleChange({
            target: {
                name: 'school_name',
                value: schoolName,
            },
        });
    };

    function handleSubmit(e) {
        e.preventDefault();

        if (email !== mailConfirm)
            return setDisplayMessage('De e-mail adressen komen niet overeen');

        if (!isSchoolsTrainingPage) {
            if (!school_name)
                return setDisplayMessage('Je hebt nog geen school ingevoerd');
        }
        if (hasDietQuestion === true) {
            if (hasDietWishes === null) {
                return setDisplayMessage(
                    'Je hebt je dieetvoorkeuren nog niet aangegeven'
                );
            }
            if (hasDietWishes === true) {
                if (diet_remarks.length === 0)
                    return setDisplayMessage(
                        'Je hebt aangegeven dat je dieetvoorkeuren hebt maar deze niet ingevuld'
                    );
            }
        }

        dispatch(
            subscribeToTraining({
                ...formValues,
                id: training?.id,
                manager_approves: hasManagerApproval,
                extra_fields: [
                    ...extra_fields,
                    {
                        question: 'Dieet wensen',
                        answer: diet_remarks,
                    },
                ],
            })
        )
            .then(() => {
                clearForm();
                dispatch(trainingIndex());
                setConfirmModalIsOpen(true);
            })
            .catch((e) => {
                if (e?.response?.data?.message) {
                    console.log(e?.response?.data?.message);
                    setDisplayMessage(e?.response?.data?.message);
                } else {
                    setDisplayMessage('Er ging iets mis met de aanmelding');
                }
            });
    }

    useEffect(() => {
        setConfirmModalIsOpen(false);
    }, [pathname]);

    const slug = isAgendaPage
        ? `/agenda/event-popup/${training?.id}/aanmelden`
        : isSchoolsTrainingPage
        ? `/school-aanbod/${training_url}/training-popup/${training?.id}/aanmelden`
        : `/${basePath}/training-popup/${training?.id}/aanmelden`;

    return (
        <Modal slug={slug}>
            {!confirmModalIsOpen ? (
                <div
                    styleName={`content ${
                        isSchoolsTrainingPage ? 'school' : ''
                    }`}
                >
                    <h2>{training?.name}</h2>
                    <form onSubmit={handleSubmit}>
                        <div styleName="column">
                            <div>
                                <TextInput
                                    label="Voornaam* | First name*"
                                    name="first_name"
                                    value={first_name}
                                    onChange={handleChange}
                                />
                            </div>
                            <div>
                                <TextInput
                                    label="Tussenvoegsel | Prefix"
                                    required={false}
                                    name="tussenvoegsel"
                                    value={tussenvoegsel}
                                    onChange={handleChange}
                                />
                            </div>
                            <div>
                                <TextInput
                                    label="Achternaam* | Last name*"
                                    name="last_name"
                                    value={last_name}
                                    onChange={handleChange}
                                />
                            </div>
                            <div>
                                <TextInput
                                    label="E-mail* (WERK E-MAIL VAN JE SCHOOL) | Email (work account)*"
                                    name="email"
                                    type="email"
                                    value={email}
                                    onChange={handleChange}
                                />
                            </div>
                            <div>
                                <TextInput
                                    label="E-mail bevestiging* (WERK E-MAIL VAN JE SCHOOL) | Confirm email (work account)*"
                                    name="mailConfirm"
                                    type="email"
                                    value={mailConfirm}
                                    onChange={(e) => {
                                        setDisplayMessage('');
                                        setMailConfirm(e.target.value);
                                    }}
                                />
                            </div>
                            <div>
                                <TextInput
                                    label="Functie en afdeling* | Function and department*"
                                    name="position"
                                    value={position}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        <div styleName="column">
                            {!hideSchoolField ? (
                                <div>
                                    {/* <TextInput
                                    label="Schoolnaam en schoollocatie **"
                                    name="school_name"
                                    value={school_name}
                                    onChange={handleChange}
                                /> */}
                                    <SingleItemDropdown
                                        label="School *"
                                        text={
                                            school_name ||
                                            'Selecteer school | Select school'
                                        }
                                        options={
                                            isSchoolsTrainingPage
                                                ? schoolTrainingOptions
                                                : schoolOptions
                                        }
                                        selected={school_name}
                                        setSelected={setSchool}
                                    />
                                </div>
                            ) : null}
                            <div>
                                <TextInput
                                    label="Ben je OP of OOP?* | Are you OP (teaching staff) or OOP (educational support staff)?*"
                                    name="op_or_oop"
                                    value={op_or_oop}
                                    required
                                    onChange={handleChange}
                                />
                            </div>
                            {!isSchoolsTrainingPage && (
                                <>
                                    {training?.is_free === 0 ? (
                                        <>
                                            <div>
                                                <TextInput
                                                    label="Naam leidinggevende | Manager's name*"
                                                    name="manager_name"
                                                    value={manager_name}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                            <div>
                                                <TextInput
                                                    label="E-mail leidinggevende | Manager's email*"
                                                    name="manager_email"
                                                    type="email"
                                                    value={manager_email}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </>
                                    ) : null}
                                </>
                            )}
                            {hasDietQuestion && (
                                <>
                                    <p styleName="food-text">
                                        Heb je dieetwensen waar we rekening mee
                                        moeten houden? * | Do you have any
                                        dietary requirements we should be aware
                                        of? *
                                    </p>
                                    <div styleName="radio-circles">
                                        <RadioCircle
                                            onClick={() =>
                                                setHasDietWishes(true)
                                            }
                                            isSelected={hasDietWishes === true}
                                            label="Ja | Yes"
                                        />
                                        <RadioCircle
                                            onClick={() =>
                                                setHasDietWishes(false)
                                            }
                                            isSelected={hasDietWishes === false}
                                            label="Nee | No"
                                        />
                                    </div>
                                    {hasDietWishes === true && (
                                        <div>
                                            <TextInput
                                                label="Dieetwensen | Dietary requirements"
                                                name="diet_remarks"
                                                value={diet_remarks}
                                                required={false}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    )}
                                </>
                            )}
                            {!isSchoolsTrainingPage && (
                                <>
                                    {training?.is_free === 0 ? (
                                        <>
                                            <p>
                                                {' '}
                                                Om deel te kunnen nemen is het
                                                van belang dat je toestemming
                                                hebt van je leidinggevende. | To
                                                participate, you need to have
                                                your manager's approval.
                                            </p>
                                            <div
                                                onClick={() =>
                                                    setHasManagerApproval(
                                                        (prev) => !prev
                                                    )
                                                }
                                                styleName="checkbox"
                                            >
                                                <Checkbox
                                                    isSelected={
                                                        hasManagerApproval
                                                    }
                                                />
                                                <p styleName="leader-text">
                                                    Ik heb deze
                                                    opleiding/training met mijn
                                                    leidinggevende besproken en
                                                    hij/zij is akkoord met mijn
                                                    deelname. | I have discussed
                                                    this course with my manager
                                                    and he/she agrees with my
                                                    participation.
                                                </p>
                                            </div>
                                        </>
                                    ) : null}
                                    <div />
                                </>
                            )}

                            <p styleName="leader-text">*Verplicht | Required</p>
                        </div>
                        <div styleName="bottom">
                            {!!training?.extra_fields?.length &&
                                training.extra_fields.map((field, i) => (
                                    <div key={field.attributes.question}>
                                        <TextAreaInput
                                            label={`${
                                                field.attributes.question
                                            } ${
                                                field.attributes.required
                                                    ? '*'
                                                    : ''
                                            }`}
                                            name={field.attributes.question}
                                            required={field.attributes.required}
                                            value={extra_fields[i]?.answer}
                                            onChange={(e) =>
                                                setFormValues((prev) => ({
                                                    ...prev,
                                                    extra_fields: prev.extra_fields?.map(
                                                        (f, index) =>
                                                            i === index
                                                                ? {
                                                                      ...f,
                                                                      answer:
                                                                          e
                                                                              .target
                                                                              .value,
                                                                  }
                                                                : f
                                                    ),
                                                }))
                                            }
                                        />
                                    </div>
                                ))}
                            {displayMessage && (
                                <p styleName="error">{displayMessage}</p>
                            )}
                            <div>
                                <Button>Verzenden | Submit</Button>
                            </div>
                        </div>
                    </form>
                </div>
            ) : (
                <div styleName="confirm">
                    <h2>Bedankt voor je inschrijving!</h2>
                    <p>
                        We hebben je aanmelding in ontvangst genomen. Controleer
                        je mailbox, hierin heb je een bevestiging gekregen van
                        de aanmelding voor {training?.name}.
                    </p>

                    <h2>Thanks for your application!</h2>
                    <p>
                        We have received your application. Please check your
                        inbox, we have send you a confirmation of your
                        application for {training?.name}.
                    </p>
                    <Button onClick={closeUrlModal}>
                        Terug naar overzicht | Back to overview
                    </Button>
                </div>
            )}
        </Modal>
    );
}
